import angular from "angular";
import { Chart, registerables } from "chart.js";
import { AppModule } from "./app.module";

Chart.register(...registerables);

angular.element(() => angular.bootstrap(document, [AppModule], { strictDi: true }));
